export default __webpack_public_path__ + "../staticImages/sprite-rechnung-2x.png";